import axios from "axios";
import SessionManager from "@/utils/session-manager";
import {red} from './config';

export default class PayClient {
  static request(options={}) {
    return axios(this._prepareOptions(options))
  }

  static _prepareOptions(givenOptions) {
    if(!givenOptions.headers) givenOptions.headers = {}

    if(!givenOptions.headers["Accept"]) givenOptions.headers["Accept"] = 'application/json'
    
    if(!givenOptions.headers["Content-Type"]) givenOptions.headers["Content-Type"] = 'application/json'

    const accessToken = SessionManager.getAuthToken()

    if(accessToken) {
      givenOptions.headers = Object.assign(givenOptions.headers, {
        Authorization: `${accessToken}`
      })
    }

    givenOptions.data = JSON.stringify(givenOptions.data)
    givenOptions.url = `${red}/${givenOptions.url}`
    return givenOptions
  }

  static criarBoleto(id) {
    return this.request({
      url: `api/v1/ABC`,
      method: "POST",
      data:{IDReserva:id}
    })
    .then((response) => {
      return response.data;
    })
  }
}


// WEBPACK FOOTER //
// ./src/utils/pay-client.js